<template>
  <footer>
    <div v-if="mobile == 0">
      <div class="center clear" v-if="$route.path  =='/'">
        <div class="changeLanBox left">
          <img src="../../assets/diqiu.png" alt="">
          <select v-model="language" @change="setLang" ref="selectVal">
            <option value="zh_CN" :selected="language == 'zh_CN'">简体中文（China）</option>
            <option value="zh_HANT" :selected="language == 'zh_HANT'">繁體中文（China）</option>
            <option value="en_US" :selected="language == 'en_US'">English (United States)</option>
          </select>
        </div>
        <div class="clauseBox right clear">
          <span v-if="this.$i18n.locale != 'zh_HANT'"><a target="_blank"
              :href="language === 'zh_CN' ? 'https://passport.lenovo.com/staticid/zh/rule.html ' : 'https://www.lenovo.com/us/en/legal/'">{{$t("home.legal")}}</a></span>
          <span v-if="this.$i18n.locale != 'zh_HANT'"><a target="_blank"
              :href="language === 'zh_CN' ? 'https://passport.lenovo.com/shop/new/zh/' : 'https://www.lenovo.com/us/en/privacy/'">{{$t("home.privacy")}}</a></span>
          <span v-if="this.$i18n.locale == 'zh_HANT'"><a target="_blank"
              href="https://www.lenovo.com/tw/zh/legal/">{{$t("home.legal")}}</a></span>
          <span v-if="this.$i18n.locale == 'zh_HANT'"><a target="_blank"
              href="https://www.lenovo.com/tw/zh/privacy/">{{$t("home.privacy")}}</a></span>
          <span>{{time}}</span>
        </div>
      </div>
      <div class="all-footer clear" v-if="$route.path  !='/'">
        <span class="footer-span">{{time}}</span>
      </div>
    </div>
    <!-- 手机端 -->
    <div v-else class="moboileFooter">
      <div class="center clear" v-if="$route.path  =='/'">
        <div class="changeLanBox left">
          <img src="../../assets/diqiu.png" alt="">
          <select v-model="language" @change="setLang" ref="selectVal">
            <option value="zh_CN" :selected="language == 'zh_CN'">简体中文（China）</option>
            <option value="zh_HANT" :selected="language == 'zh_HANT'">繁體中文（China）</option>
            <option value="en_US" :selected="language == 'en_US'">English (United States)</option>
          </select>
        </div>
        <div class="clauseBox right clear">
          <span v-if="this.$i18n.locale != 'zh_HANT'"><a target="_blank"
              :href="language === 'zh_CN' ? 'https://passport.lenovo.com/staticid/zh/rule.html' : 'https://www.lenovo.com/us/en/legal/'">{{$t("home.legal")}}</a></span>
          <span v-if="this.$i18n.locale != 'zh_HANT'"><a target="_blank"
              :href="language === 'zh_CN' ? 'https://passport.lenovo.com/shop/new/zh/' : 'https://www.lenovo.com/us/en/privacy/'">{{$t("home.privacy")}}</a></span>
          <span v-if="this.$i18n.locale == 'zh_HANT'"><a target="_blank"
              href="https://www.lenovo.com/tw/zh/legal/">{{$t("home.legal")}}</a></span>
          <span v-if="this.$i18n.locale == 'zh_HANT'"><a target="_blank"
              href="https://www.lenovo.com/tw/zh/privacy/">{{$t("home.privacy")}}</a></span>
          <span>{{time}}</span>
        </div>
      </div>
      <div class="all-footer clear" v-if="$route.path  !='/'">
        <span class="footer-span">{{time}}</span>
      </div>
    </div>
  </footer>
</template>

<script>
  export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    props: ['mobile'],
    data() {
      //这里存放数据
      var data = new Date()
      var initTime = "© " + data.getFullYear() + " Lenovo Group"
      return {
        time: initTime ? initTime : "© 2010 Lenovo Group",
        language: this.$i18n.locale
      };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {

    },
    //方法集合
    methods: {
      setLang() {
        this.$i18n.locale = this.language;
        this.$http.setCookie(this.language).then(() => {});
      }

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.$http.getCookie().then((data) => {
          let lang = data.data.lang == "en_US" || data.data.lang == "zh_CN" || data.data.lang == "zh_HANT" ? data.data.lang : "zh_CN";
            if (data.data.location != "CN" ) {
              lang = data.data.lang == "en_US" || data.data.lang == "zh_CN" || data.data.lang == "zh_HANT" ? data.data.lang : "en_US";;
            }
          this.$i18n.locale = lang;
          this.language = lang;
        }).catch((err) => {
          this.$i18n.locale = 'zh_CN';
          this.language = 'zh_CN';
      });
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>
<style scoped lang="scss">
  .all-footer {
    background-color: #F3F3F3;
    text-align: center;
  }

  .footer-span {
    width: 100%;
    color: #393939;
    height: 33PX;
  }

  .left {
    float: left;
  }

  .right {
    float: right;
  }

  @media screen and (min-width: 600PX) {
    footer {
      bottom: 0;
      width: 100%;
      height: 33PX;
      line-height: 33PX;
      font-size: 13PX;
      color: #393939;
      background: #fff;
      position: fixed;

      .center {
        padding: 0 10%;
      }

      a {
        color: #393939;
        font-size: 13PX;
      }

      .changeLanBox {
        img {
          width: 14PX;
          height: 14PX;
          vertical-align: middle;
        }

        select {
          border: none;
          outline: none;
          font-size: 13PX;
          background-color: transparent;
          appearance: none;
          margin-left: 6PX;
        }
      }

      .clauseBox {
        span:last-child {
          margin-right: 0;
        }
      }
    }
  }

  @media screen and (max-width: 600PX) {
    footer {
      bottom: 0PX;
      width: 100%;
      line-height: 26PX;
      font-size: 13PX;
      color: #393939;
      position: fixed;
      background: #fff;

      .center {
        padding: 0 14%;
      }

      a {
        color: #393939;
        font-size: 13PX;
      }

      .changeLanBox {
        margin-right: 30PX;

        img {
          width: 18PX;
          height: 18PX;
          vertical-align: middle;
        }

        select {
          border: none;
          outline: none;
          font-size: 13PX;
          background-color: transparent;
          appearance: none;
          margin-left: 6PX;
          margin-bottom: 3PX;
        }
      }

      .clauseBox {
        float: left;

        span {
          margin-right: 20PX;
        }

        span:last-child {
          margin-right: 0;
        }
      }
    }
  }
  .moboileFooter{
    font-size: 12PX!important;
    .center{
      padding: 0 20PX;
    }
    .changeLanBox{
      margin-right: 0;
      font-size: 12PX;
    }
    .clauseBox{
      margin-left: 8PX;
      span{
        margin-right: 0;
      }
    }

    
    .changeLanBox select{
      margin-left: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue